import React from 'react';
import { Fancybox } from '@fancyapps/ui';
import FullScreenButton from '@@components/FullScreenButton/FullScreenButton';
import ImageLoader from '@@components/ImageLoader/ImageLoader';
import Slider, { Settings } from 'react-slick';

const settings: Settings = {
    arrows: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    responsive: [
        {
            breakpoint: 576,
            settings: {
                arrows: false,
            },
        },
    ],
};

type TSlide = {
    image: {
        src: string;
        alt: string;
    };
};

type TSimpleSliderProps = {
    readonly slides: TSlide[];
};

const SimpleSlider: React.FC<TSimpleSliderProps> = ({ slides }) => {
    const createFancyGallery = (): void => {
        const fancyGallerySlides = slides.map((content: TSlide) => {
            return { src: content.image.src, caption: content.image.alt };
        });

        Fancybox.show(fancyGallerySlides, { hideScrollbar: true });
    };

    return (
        <div className='simple-slider'>
            <Slider {...settings}>
                {slides.map((slide: TSlide, index: number) => (
                    <div key={index}>
                        <ImageLoader
                            className='max-w-full h-auto'
                            src={slide.image.src}
                            alt={slide.image.alt}
                            minHeight={340}
                        />
                    </div>
                ))}
            </Slider>
            <FullScreenButton onClick={createFancyGallery} />
        </div>
    );
};

export type { TSlide };
export default SimpleSlider;
